import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import "../src/assets/i18n/i18n/config.js"
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

import { rootSaga, store, sagaMiddleware } from './store/redux/sagas'
import { Provider } from 'react-redux';
import { HelmetProvider } from 'react-helmet-async';
sagaMiddleware.run(rootSaga)

// usen under saga
const App = React.lazy(() => import("./App"));

const CenteredSpinner = () => (
  <div style={{
    height: '100vh',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  }}>
    {/* <Spin size="large" /> */}
  </div>
);

const RootComponent = () => {

  let isHeadlesss = localStorage?.getItem('headlessDetected') === 'true'
  let isHeadless = (
    navigator.webdriver ||
    /HeadlessChrome/.test(navigator.userAgent)
  );

  if (isHeadless) {
    // console.warn("🚨 Headless browser detected");
    isHeadlesss = true
    localStorage.setItem('headlessDetected', 'true');
  }

  React.useEffect(() => {
    import("./App");
  }, []);


  if (isHeadlesss) {
    return (
      <div style={{ padding: 20, color: 'red', fontWeight: 'bold' }}>
        Access Denied: Browser detected.
      </div>
    );
  }

  return (
    <React.StrictMode>
      <Provider store={store}>
        <BrowserRouter>
          <React.Suspense fallback={<CenteredSpinner />}>
            <HelmetProvider>
              <App />
            </HelmetProvider>
          </React.Suspense>
        </BrowserRouter>
      </Provider>
    </React.StrictMode>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<RootComponent />);

reportWebVitals();
